export enum modalStatus {
    ACTIVE = 'active',
    HIDDEN = 'hidden',
}

export enum modalURLs {
    APROVE_REQ = 'modalAprobar',
    DELETE_REQ = 'delReq',
    EDIT_REQ = 'editReq',
    NEW_REQ = 'newReq',
    EMAIL_PASS_CHECKER = "emailPassChecker",
    EMAIL_CHECKER = "emailChecker",
    RESET_PASS = 'resetPass',
    PASSWORD_EXPIRATION = 'passwordExpirations'
}

export enum modalLabels {
    NEW_REQ = 'Nueva solicitud',
}